/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentProtocolEnum } from './ConversationalAgentProtocolEnum';
import {
  ConversationalAgentProtocolEnumFromJSON,
  ConversationalAgentProtocolEnumFromJSONTyped,
  ConversationalAgentProtocolEnumToJSON,
} from './ConversationalAgentProtocolEnum';

/**
 * Polymorphic serializer base class.
 *
 * Note that the discriminator field must exist at the same depth as the mapped
 * serializer fields for the OpenAPI introspection. See
 * https://swagger.io/docs/specification/data-models/inheritance-and-polymorphism/ for
 * more information. As such, it's not possible to define something like:
 *
 * {
 *     "object_type": "foo",
 *     "polymorphic_context": {
 *         <foo-specific fields>
 *     }
 * }
 *
 * without explicitly wrapping this in a parent serializer, i.e. -
 * ``polymorphic_context`` can not be a PolymorphicSerializer itself, as it requires
 * access to the ``object_type`` in the parent scope.
 * @export
 * @interface ConversationalAgentInferencerPolymorphicShared
 */
export interface ConversationalAgentInferencerPolymorphicShared {
  /**
   *
   * @type {ConversationalAgentProtocolEnum}
   * @memberof ConversationalAgentInferencerPolymorphicShared
   */
  protocol: ConversationalAgentProtocolEnum;
}

/**
 * Check if a given object implements the ConversationalAgentInferencerPolymorphicShared interface.
 */
export function instanceOfConversationalAgentInferencerPolymorphicShared(
  value: object,
): value is ConversationalAgentInferencerPolymorphicShared {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  return true;
}

export function ConversationalAgentInferencerPolymorphicSharedFromJSON(
  json: any,
): ConversationalAgentInferencerPolymorphicShared {
  return ConversationalAgentInferencerPolymorphicSharedFromJSONTyped(json, false);
}

export function ConversationalAgentInferencerPolymorphicSharedFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationalAgentInferencerPolymorphicShared {
  if (json == null) {
    return json;
  }
  return {
    protocol: ConversationalAgentProtocolEnumFromJSON(json['protocol']),
  };
}

export function ConversationalAgentInferencerPolymorphicSharedToJSON(
  value?: ConversationalAgentInferencerPolymorphicShared | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: ConversationalAgentProtocolEnumToJSON(value['protocol']),
  };
}
